import { render, staticRenderFns } from "./RecordDialog.vue?vue&type=template&id=03234e9b&scoped=true"
import script from "./RecordDialog.vue?vue&type=script&lang=js"
export * from "./RecordDialog.vue?vue&type=script&lang=js"
import style0 from "./RecordDialog.vue?vue&type=style&index=0&id=03234e9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03234e9b",
  null
  
)

export default component.exports